module.exports = __webpack_public_path__ + "static/media/pay-top.0d302852.png";